import type { CriteoState } from './Criteo.types';

export const INIT_STATE: CriteoState = {
  adAccounts: [],
  adAccountStatuses: {},
  authenticationUrl: '',
  loading: false,
};
